import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { DwellingService } from '../../service/data/dwelling.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { Subscription } from 'rxjs';
import { AutoCompleteModel } from '../../../core/component/autocomplete/autocomplete-model';
import { LettingAdvertisment } from '../../../letting/model/letting-advertisment';
import { LettingAdvertismentService } from '../../../letting/service/letting-advertisment.service';

@Component({
    selector: 'app-set-homeq-offices-form',
    templateUrl: './set-homeq-offices-form.component.html',
    styleUrls: ['./set-homeq-offices-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SetHomeqOfficesFormComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _dwellingService: DwellingService,
    private _advertService: LettingAdvertismentService,
    private _messageService: MessageService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  private subscription = new Subscription();
  working = false;

  @Input() dataContext: LettingAdvertisment;
  homeQOffices: AutoCompleteModel[];
  form: FormGroup;
  assignedOffice: AutoCompleteModel;
  initialized: boolean = false;

  ngOnInit(): void {
    this.subscription.add(
      this._dwellingService.getAndSendHomeqCompanies(this.dataContext.rentalObjectId).subscribe(res => {
        this.homeQOffices = res.companies;
        this.createForm();
        this.initialized = true;
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription = null;
  }

  private createForm() {
    this.form = this._fb.group({
      homeQOffice: this._fcf.createMandatory('PROPERTY.HOMEQ_OFFICE', null),
    });
  }

  get disableSubmit() {
    return this.working || !this.initialized || !this.form.valid;
  }

  onSubmit() {
    this.working = true;
    this.subscription.add(
      this._advertService.sendToPlatform(this.dataContext.id, this.form.value.homeQOffice.id).subscribe({
        next: res => {
          this._messageService.showSuccess('LETTING.ADVERTISMENT.HOMEQ.ADVERTISEMENT_SENT_SUCCESS');
          this._dialogService.complete(res);
        },
        complete: () => {
          this.working = false;
        },
      })
    );
  }

  onCancel() {
    this._dialogService.close();
  }
}
